export const AB_TRT_DEFAULT_VALUE = {
  patient: {
    male: true
  },
  fasting: {
    routine: true
  },
  hematology: {
    cbcAndDifferential: true
  },
  endocrine: {
    estradiol: true,
    FSH: true,
    LH: true,
    prolactin: true,
    testosteroneTotal: true,
    TSH: true
  },
  generalChemistry: {
    albumin: true,
    ALP: true,
    ALT: true,
    CRP: true,
    eGFR: true,
    ferritin: true,
    glucoseFasting: true,
    hemoglobinA1c: true,
    lipase: true,
    NA: true,
    K: true,
    lipidPanel: true,
    PSA: true
  },
  additionalTests: {
    additionalTests: 'B12, Total Insulin, Testosterone (free)'
  }
};

export const AB_WL_DEFAULT_VALUE = {
  fasting: {
    routine: true
  },
  hematology: {
    cbcAndDifferential: true
  },
  endocrine: {
    TSH: true
  },
  generalChemistry: {
    albumin: true,
    ALP: true,
    ALT: true,
    CRP: true,
    eGFR: true,
    ferritin: true,
    glucoseFasting: true,
    hemoglobinA1c: true,
    lipase: true,
    NA: true,
    K: true,
    lipidPanel: true
  },
  additionalTests: {
    additionalTests: 'B12, Total Insulin'
  }
};

export const AB_LGV_DEFAULT_VALUE = ({ customer, organization }) => {
  const jackLgvExtraTests =
    'Lipoprotein(a), AST, Free T3/Free T4, Serum iron (Fe), TIBC, % transferrin saturation, Nucleated RBC (NRBC)';
  const jillLgvExtraTests =
    'DHEA-S, Serum iron (Fe), TIBC, % transferrin saturation, Free T3/Free T4, Lipoprotein(a), Nucleated RBC (NRBC), Apolipoprotein B (ApoB)';
  const defaultsByProfile = {
    jack_health: {
      ...AB_TRT_DEFAULT_VALUE,
      endocrine: {
        ...AB_TRT_DEFAULT_VALUE.endocrine,
        random: true
      },
      generalChemistry: {
        ...AB_TRT_DEFAULT_VALUE.generalChemistry,
        magnesium: true,
        urate: true,
        AST: true,
        PSA: false,
        triglycerides: true,
        cholesterolTotal: true,
        calcium: true,
        GGT: true,
        phosphate: true
      },
      additionalTests: {
        additionalTests: `${AB_TRT_DEFAULT_VALUE.additionalTests.additionalTests}, ${jackLgvExtraTests}`
      }
    },
    jill_health: {
      ...AB_WL_DEFAULT_VALUE,
      endocrine: {
        ...AB_WL_DEFAULT_VALUE.endocrine,
        progesterone: true,
        estradiol: true,
        LH: true,
        prolactin: true,
        testosteroneTotal: true,
        FSH: true,
        random: true
      },
      generalChemistry: {
        ...AB_WL_DEFAULT_VALUE.generalChemistry,
        triglycerides: true,
        cholesterolTotal: true,
        calcium: true,
        GGT: true,
        magnesium: true,
        phosphate: true,
        urate: true,
        AST: true
      },
      additionalTests: {
        additionalTests: `${AB_WL_DEFAULT_VALUE.additionalTests.additionalTests}, ${jillLgvExtraTests}`
      }
    }
  };
  const normalizedGender = customer?.gender?.toLowerCase?.();
  if (normalizedGender === 'male' || normalizedGender === 'm') {
    return defaultsByProfile.jack_health;
  }
  if (normalizedGender === 'female' || normalizedGender === 'f') {
    return defaultsByProfile.jill_health;
  }
  return defaultsByProfile[organization] || defaultsByProfile.jack_health;
};

